import Modal from "@/components/atoms/Modal";
import { SelectPaginateAsync } from "@/components/atoms/Select";
import useLoadOptions from "@/hooks/useLoadOptions";
import { TeamUserForm } from "@/interfaces/TeamUser";
import { IModalMethods } from "@/interfaces/Modal";
import { useStoreTeamUserMutation } from "@/services/teams/users";
import {
  ElementRef,
  ForwardRefRenderFunction,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";

const StoreTeamUserModal: ForwardRefRenderFunction<
  IModalMethods,
  { teamId: string }
> = ({ teamId }, ref) => {
  const ModalRef = useRef<ElementRef<typeof Modal>>(null);
  const { control, handleSubmit } = useForm<TeamUserForm>();
  const { loadUsersOptions } = useLoadOptions();
  const [storeTeamUserAsync] = useStoreTeamUserMutation();

  const showOrHiddenModal = () => ModalRef.current?.showOrHiddenModal();

  useImperativeHandle(ref, () => ({
    showOrHiddenModal,
  }));

  const onSubmit: SubmitHandler<TeamUserForm> = async ({
    user: selectedUser,
  }) => {
    if (!selectedUser) return;
    return await toast.promise(
      storeTeamUserAsync([
        teamId,
        {
          userId: selectedUser.id,
        },
      ]).unwrap(),
      {
        pending: "Ajout du membre en cours...",
        success: {
          render() {
            showOrHiddenModal();
            return (
              <p style={{ marginBottom: 0, textAlign: "center" }}>
                Le membre a bien été ajouté
              </p>
            );
          },
        },
        error: {
          render() {
            return "Une erreur est survenue";
          },
        },
      },
    );
  };

  return (
    <Modal
      ref={ModalRef}
      title="Ajouter un membre"
      requiredLabel
      onSubmit={handleSubmit(onSubmit)}
    >
      <Row className="gx-3">
        <Col lg={6}>
          <Form.Group className="mb-3">
            <Form.Label>
              Utilisateur <span className="text-danger">*</span> :
            </Form.Label>
            <Controller
              control={control}
              name="user"
              rules={{ required: true }}
              render={({ field }) => (
                <SelectPaginateAsync
                  loadOptions={loadUsersOptions}
                  getOptionLabel={(option) => option.fullname}
                  getOptionValue={(option) => option.id}
                  value={field.value}
                  onChange={field.onChange}
                  additional={{ pageIndex: 0 }}
                />
              )}
            />
          </Form.Group>
        </Col>
      </Row>
    </Modal>
  );
};

export default forwardRef(StoreTeamUserModal);
